export default {
  firebase: {
    //apiKey: "AIzaSyCReq2VZfQ6QNHqL4X7lG43rkmJzn-_R0g",
    apiKey: "AIzaSyDNw3lknM-dGdNXIJeplSiZI67Huv20eEI",
    //authDomain: "playbookstaging.firebaseapp.com",
    authDomain: "playbook-sales.firebaseapp.com",
    //databaseURL: "https://playbookstaging.firebaseio.com",
    databaseURL: "https://playbook-sales.firebaseio.com",
    //projectId: "playbookstaging",
    projectId: "playbook-sales",

    storageBucket: "playbook-sales.appspot.com",

    messagingSenderId: "36313793548",
    appId: "1:36313793548:web:640ed4255b675663"
  },
  // midServer: 'http://localhost:5001/playbookstaging/us-central1'
  midServer: 'https://us-central1-playbookstaging.cloudfunctions.net'
}



// WEBPACK FOOTER //
// ./src/config/index.js